import {lazy} from 'react';

export const MobileHeaderLazy = lazy(() => import(/* webpackChunkName: "mobileHeader" */ '.'));
